/*
 * IMPORTANT:
 *
 * As of June 2023, any new experiments should be added to `blog-client` repo.
 * Common: https://github.com/wix-private/blog-client/blob/master/packages/communities-blog-client-common/src/constants/experiments.ts
 * BM: https://github.com/wix-private/blog-client/blob/master/packages/communities-blog-bm/src/constants/experiments.ts
 * OOI: https://github.com/wix-private/blog-client/blob/master/packages/communities-blog-ooi/src/experiments.ts
 * Settings: https://github.com/wix-private/blog-client/blob/master/packages/communities-blog-settings/src/experiments.ts
 *
 * The experiments below will remain until removed.
 */
export var EXPERIMENT_BLOCK_VIEW_COUNT_UPDATES = 'specs.wixBlog.BlockViewCountUpdates';
export var EXPERIMENT_BM_QA_DISPLAY_LIMIT_WARNINGS = 'specs.wixBlog.DisplayLimitWarnings';
export var EXPERIMENT_BM_USE_RICS_ON_BUSY_CHANGE = 'specs.wixBlog.BMUseRicosOnBusyChange';
export var EXPERIMENT_COMPOSER_TOOLBAR_DISPLAY_FONT = 'specs.wixBlog.ComposerToolbarDisplayFont';
export var EXPERIMENT_CTA_IN_AMP_HEADER = 'specs.wixBlog.CTAinAMPHeader';
export var EXPERIMENT_DEVELOPER_LOGGING = 'specs.wixBlog.developerLogging';
export var EXPERIMENT_DONT_CALL_DB_ON_BAD_SLUG = 'specs.wixBlog.DontCallDbOnBadSlug';
export var EXPERIMENT_HASHTAG_PAGE_USE_FEED_PAGE = 'specs.wixBlog.HashtagPageUseFeedPage';
export var EXPERIMENT_MIGRATE_CUSTOM_FEED_ON_EDITOR_READY = 'specs.wixBlog.MigrateCustomFeedOnEditorReady';
export var EXPERIMENT_ML_PROVISION_USE_EVENT_DATA = 'specs.wixBlog.MultilingualProvisionUseEventData';
export var EXPERIMENT_RICOS_EMBED_BUTTONS = 'specs.wixBlog.RicosEmbedButtons';
export var EXPERIMENT_TOGGLE_POST_INDEX_SEO_SETTINGS = 'specs.wixBlog.TogglePostIndexSEOSettings';
export var EXPERIMENT_ULTIMATE_MIGRATION_UNPUBLISHED_SITES = 'specs.wixBlog.UnpublishedSiteMigration';
export var EXPERIMENT_USE_SITE_ROOT_LINKS = 'specs.wixBlog.UseSiteRootLinks';
export var EXPERIMENT_USE_LAYOUT_FIXER = 'specs.wixBlog.UseLayoutFixer';
export var EXPERIMENT_WIX_COMMENTS_USE_REACTIONS = 'specs.wixBlog.CommentsUseReactions';
export var EXPERIMENT_LIVE_SITE_EDITING_DEPRECATION = 'specs.wixBlog.LiveSiteEditorDeprication';
export var EXPERIMENT_USE_PLATFORMIZED_FETCH_POST_AMP = 'specs.wixBlog.UsePlatformizedFetchPostAmp';
